import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const MY_PREFERENCE_QUERY = gqlTagGira`
    query jira_deploymentsPage_getMyPreferences_Query($keys: [String!]!) {
        myPreferences(keys: $keys)
    }
`;

export const SET_MY_PREFERENCE_MUTATION = gqlTagGira`
    mutation jira_deploymentsPage_setMyPreference_Mutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
